import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto mt-16 text-center">
      <div className="rs-underline mx-auto mb-6" />
      <h1 data-testid="payment-cancel-title" className="font-display-heavy text-5xl">PAYMENT CANCELED</h1>
      <p className="text-neutral-400 mt-4">No charge was made. You can try again anytime.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/pricing"><Button className="h-12 px-6 bg-red-600 hover:bg-red-700 font-semibold">Back to pricing</Button></Link>
      </div>
    </div>
  );
}
